import styled from 'styled-components';

import { StyledButton as StyledButtonBase } from './loyalty-button-widget.styled.base';

export const StyledButton = styled(StyledButtonBase)`
  padding: 0.875rem 0;
  width: calc(100% - 80px);
`;
